import React from "react";
import { useMsal } from "@azure/msal-react";
import { config } from "../../config";
import Button from "./Button";

interface LogoutButtonInterface {
  oktaIdToken?: string;
  setIsLoading: (isLoading: boolean) => void;
  userRemoved: () => void;
  identityProvider: string;
}

const LogoutButton: React.FC<LogoutButtonInterface> = ({ oktaIdToken, setIsLoading, userRemoved, identityProvider }) => {
  const { instance } = useMsal();

  const handleLogout = async () => {
    switch (identityProvider) {
      case "Entra":
        await handleEntraLogout();
        break;
      case "Okta":
        await handleOktaLogout();
        break;
      default:
        console.error("Unknown identity provider:", identityProvider);
    }
  }

  const handleEntraLogout = async () => {
    setIsLoading(true);
    try {
      await instance.logoutPopup().then(async (response) => {
        await instance.ssoSilent({ scopes: ["user.read"] })
          .then((response) => {
            console.log("Logout canceled:", response);
          })
          .catch((_) => {
            userRemoved();
            console.log("Logout successful:", response);
          });
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Logout failed:', error);
      setIsLoading(false);
    }
  };

  const handleOktaLogout = async () => {
    setIsLoading(true);
    try {
      userRemoved();
      console.log("Okta Logout successful.");

      let oktaConfig = config.okta;
      const logoutUrl = `${oktaConfig.issuer}/v1/logout` +
        `?id_token_hint=${oktaIdToken}` +
        `&post_logout_redirect_uri=${oktaConfig.postLogoutRedirectUriBase}logout-okta.html`;
      window.location.href = logoutUrl;
    } catch (error) {
      console.error("Okta Logout failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return <Button label="Sign out" onClick={handleLogout} />;
};

export default LogoutButton;
